import React from 'react';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { ClosingDateNotice } from './ClosingDateNotice';

export const ClosingDateTimelineNoLongerFitsWarning = () => (
    <ClosingDateNotice
        tone="warning"
        icon={faExclamation}
        className="closing-date-timeline-no-longer-fits-warning">
        <strong>Timeline no longer fits the closing date.</strong> A remaining
        step of the last stage has less than 1 day before the closing date.
        Agree on a later date to give it time.
    </ClosingDateNotice>
);
